var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) =>
  key in obj
    ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value,
      })
    : (obj[key] = value);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  },
});
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// sticky go to checkout
var _scopeFromPassed, _scopeToReached, _intersectionObserver;
var CheckoutQuickAdd = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _scopeFromPassed, false);
    __privateAdd(this, _scopeToReached, false);
    __privateAdd(
      this,
      _intersectionObserver,
      new IntersectionObserver(this._onObserved.bind(this))
    );
  }
  connectedCallback() {
    this._scopeFrom = document.getElementById(this.getAttribute("form"));
    this._scopeTo = document.querySelector(".footer");
    if (!this._scopeFrom || !this._scopeTo) {
      return;
    }
    __privateGet(this, _intersectionObserver).observe(this._scopeFrom);
    __privateGet(this, _intersectionObserver).observe(this._scopeTo);
  }
  disconnectedCallback() {
    __privateGet(this, _intersectionObserver).disconnect();
  }
  _onObserved(entries) {
    entries.forEach((entry) => {
      if (entry.target === this._scopeFrom) {
        __privateSet(
          this,
          _scopeFromPassed,
          entry.boundingClientRect.bottom < 0
        );
      }
      if (entry.target === this._scopeTo) {
        __privateSet(this, _scopeToReached, entry.isIntersecting);
      }
    });
    this.classList.toggle("is-visible", __privateGet(this, _scopeFromPassed));
  }
};
_scopeFromPassed = new WeakMap();
_scopeToReached = new WeakMap();
_intersectionObserver = new WeakMap();
if (!window.customElements.get("checkout-quick-add")) {
  window.customElements.define("checkout-quick-add", CheckoutQuickAdd);
}

import { animate, timeline as timeline3, stagger, Delegate as Delegate2 } from "//dreamerdesigns.com/cdn/shop/t/280/assets/vendor.min.js?v=114992621884149252901769572418";
import { AnimatedDetails, EffectCarousel as EffectCarousel2, Drawer, throttle } from "//dreamerdesigns.com/cdn/shop/t/280/assets/theme.js?v=158908644413099921841769655873";
var reduceMenuAnimation = JSON.parse("false");
var DDStoreHeader = class extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute("hide-on-scroll") && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      this._lastScrollTop = 0;
      this._accumulatedScroll = 0;
      this._isVisible = true;
      this._hasSwitchedToSticky = false;
      this._percentSquash = this.getAttribute('percent-squash') || '20';
      this._scrollClass = this.getAttribute('scrolled-class') || 'is-squashed';
      window.addEventListener("scroll", throttle(this._onScroll.bind(this)));
    }
    this.addEventListener("toggle", this._checkTransparency.bind(this), { capture: true });
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        this.classList.remove("is-filled");
        this._setupTransparentHeader();
      }
    });
    this._setupTransparentHeader();
    if (this.hasAttribute("sticky")) {
      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", this._setupTransparentHeader.bind(this));
        document.addEventListener("shopify:section:unload", this._setupTransparentHeader.bind(this));
        document.addEventListener("shopify:section:reorder", this._setupTransparentHeader.bind(this));
      }
    }
  }
  hide() {
    if (this._isVisible) {
      this.classList.add(this._scrollClass);
      animate(this, { transform: ["translateY(0)", `translateY(-${this._percentSquash}%)`] }, { duration: 0.2, easing: "ease" });
      this._isVisible = false;
      if (document.querySelector('.snize-ac-results-content')) {
        document.querySelector('dd-store-header').classList.add('squash-show-search');
      }
    }
  }
  show() {
    if (!this._isVisible) {
      this.classList.remove(this._scrollClass);
      animate(this, { transform: [`translateY(-${this._percentSquash}%)`, "translateY(0)"] }, { duration: 0.2, easing: "ease" });
      this._accumulatedScroll = 0;
      this._isVisible = true;
    }
  }
  _onScroll() {
    if (window.scrollY < 0) {
      return;
    }
    this._accumulatedScroll = Math.max(0, this._accumulatedScroll + (window.scrollY - this._lastScrollTop));
    if (window.scrollY < this._lastScrollTop && this._accumulatedScroll <= parseInt(this.getAttribute("hide-on-scroll"))) {
      this.show();
    } else if (this._accumulatedScroll > parseInt(this.getAttribute("hide-on-scroll"))) {
      this.hide();
    }
    this._lastScrollTop = window.scrollY;
  }
  _checkTransparency() {
    let hasFallbackScrollDetection = false;
    if (CSS.supports("selector(:has(> *))") && this.hasAttribute("sticky") && !this.hasAttribute("hide-on-scroll") && this.hasAttribute("allow-transparency")) {
      const offsetBeforeChanging = 500;
      if (this.querySelectorAll("[open]").length > 0) {
        this.classList.add("is-filled");
      } else if (window.scrollY >= offsetBeforeChanging && !this._hasSwitchedToSticky) {
        this._hasSwitchedToSticky = true;
        this.classList.add("is-filled");
        animate(this, { transform: [`translateY(-${this._percentSquash}%)`, "translateY(0)"] }, { duration: 0.15, easing: "ease" });
      } else if (window.scrollY < offsetBeforeChanging) {
        if (this._hasSwitchedToSticky) {
          this._hasSwitchedToSticky = false;
          animate(this, { transform: ["translateY(0)", `translateY(-${this._percentSquash}%)`] }, { duration: 0.15, easing: "ease" }).finished.then(() => {
            this.style.transform = null;
            this.classList.remove("is-filled");
          });
        } else if (this.getAnimations().length === 0) {
          this.classList.remove("is-filled");
        }
      }
    } else {
      hasFallbackScrollDetection = window.scrollY > 20;
      this.classList.toggle("is-filled", !this.hasAttribute("allow-transparency") || this.querySelectorAll("[open]").length > 0 || hasFallbackScrollDetection);
    }
  }
  _setupTransparentHeader() {
    if (document.querySelector(".shopify-section:first-child [allow-transparent-header]")) {
      this.setAttribute("allow-transparency", "");
      this.addEventListener("mouseenter", this._checkTransparency.bind(this));
      this.addEventListener("mouseleave", this._checkTransparency.bind(this));
      if (this.hasAttribute("sticky")) {
        window.addEventListener("scroll", throttle(this._checkTransparency.bind(this)));
      }
      this._checkTransparency();
    } else {
      this.removeAttribute("allow-transparency");
    }
  }
};
if (!window.customElements.get("dd-store-header")) {
  window.customElements.define("dd-store-header", DDStoreHeader);
}

// js/common/utilities/cached-fetch.js
var cachedMap = /* @__PURE__ */ new Map();
function cachedFetch(url, options) {
  const cacheKey = url;
  if (cachedMap.has(cacheKey)) {
    return Promise.resolve(new Response(new Blob([cachedMap.get(cacheKey)])));
  }
  return fetch(url, options).then((response) => {
    if (response.status === 200) {
      const contentType = response.headers.get("Content-Type");
      if (contentType && (contentType.match(/application\/json/i) || contentType.match(/text\//i))) {
        response.clone().text().then((content) => {
          cachedMap.set(cacheKey, content);
        });
      }
    }
    return response;
  });
}

var openElements = /* @__PURE__ */ new Set();
var DDFacetForm = class extends HTMLFormElement {
  constructor() {
    super();
    this._isDirty = false;
    this.addEventListener("change", this._onFormChanged);
    this.addEventListener("submit", this._onFormSubmitted);

    // ONLY CHANGE TO FACET FORM
    // We need to be able to unselect radio buttons
    this.querySelectorAll("input[type=radio].can-uncheck").forEach((radio) => {
      radio.addEventListener("click", (e) => {
        if (radio.getAttribute('was-checked') === 'true') {
          radio.checked = false;
          this.dispatchEvent(new Event('change'));
        }
      });
    });
  }
  connectedCallback() {
    Array.from(this.querySelectorAll("details, facet-dialog")).forEach((disclosureElement) => {
      if (disclosureElement.open) {
        openElements.add(disclosureElement.id);
      }
      disclosureElement.addEventListener("toggle", () => {
        if (disclosureElement.open) {
          openElements.add(disclosureElement.id);
        } else {
          openElements.delete(disclosureElement.id);
        }
      });
    });
  }
  _buildUrl() {
    const searchParams = new URLSearchParams(new FormData(this)), url = new URL(this.action);
    url.search = "";
    searchParams.forEach((value, key) => url.searchParams.append(key, value));
    ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach((optionToClear) => {
      if (url.searchParams.get(optionToClear) === "") {
        url.searchParams.delete(optionToClear);
      }
    });
    url.searchParams.set("section_id", this.getAttribute("section-id"));
    return url;
  }
  _onFormChanged() {
    this._isDirty = true;
    if (this.hasAttribute("update-on-change")) {
      if (HTMLFormElement.prototype.requestSubmit) {
        this.requestSubmit();
      } else {
        this.dispatchEvent(new Event("submit", { cancelable: true }));
      }
    } else {
      cachedFetch(this._buildUrl().toString());
    }
  }
  _onFormSubmitted(event) {
    event.preventDefault();
    if (!this._isDirty) {
      return;
    }
    this.dispatchEvent(new CustomEvent("facet:update", {
      bubbles: true,
      detail: {
        url: this._buildUrl()
      }
    }));
    this._isDirty = false;
  }
};
if (!window.customElements.get("dd-facet-form")) {
  window.customElements.define("dd-facet-form", DDFacetForm, { extends: "form" });
}

// js/common/facets/facet-drawer.js
var DDFacetDrawer = class extends Drawer {
  constructor() {
    super();
    this.addEventListener("dialog:after-hide", this._submitForm);
  }
  _submitForm() {
    const form = this.querySelector("#dd-facet-form");
    if (HTMLFormElement.prototype.requestSubmit) {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event("submit", { cancelable: true }));
    }
  }
};
if (!window.customElements.get("dd-facet-drawer")) {
  window.customElements.define("dd-facet-drawer", DDFacetDrawer);
}

// js/common/facets/facet-apply-button.js
var FacetApplyButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this._closeDrawer);
    this.form.addEventListener("change", this._updateCount.bind(this));
    this.filterCountElement = document.createElement("span");
    this.appendChild(this.filterCountElement);
  }
  connectedCallback() {
    this._updateCount();
  }
  _updateCount() {
    const form = new FormData(this.form);
    this.filterCountElement.innerText = ` (${Array.from(form.values()).filter((item) => item !== "").length})`;
  }
  async _closeDrawer() {
    this.closest("dd-facet-drawer").hide();
  }
};
if (!window.customElements.get("dd-facet-apply-button")) {
  window.customElements.define("dd-facet-apply-button", FacetApplyButton, { extends: "button" });
}

function checkIfLocaleIsSet() {
  const getCountry = localStorage.getItem("dac-user-country-check");
  if (getCountry) { 
    // console.log(`country already set to ${getCountry}`);
  } else {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", "https://ipinfo.io/json", true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        const countryISO = response.country;
        if (countryISO && countryISO !== 'US') {
          const optionSelector = `.popover-listbox__option[value="${countryISO}"]`;
          // console.log(optionSelector);
          const target = document.querySelector(optionSelector);
          setTimeout(function () {
            target.click();
            localStorage.setItem('dac-user-country-check', countryISO);
          }, 1000);
        }
      }
    };
    xhr.send();
  }
}

(function () {
  // HERO show on first visit versus returning visitor
  
  const visitCount = getVisitCount();
  const isReturning = visitCount >= 5;

  if (isReturning) {
    document.body.classList.add("dd-returning-visitor");
    document.addEventListener("DOMContentLoaded", () => {
      const heroLink = document.querySelector(".hero-link");
      if (heroLink) heroLink.href = heroLink.dataset.returningHref;
    });
  } else {
    document.body.classList.add("dd-new-visitor");
  }

  function getVisitCount() {
    let count = localStorage.getItem("dd_visit_count");
    let isCounted = sessionStorage.getItem("dd_visit_is_counted");

    if (isCounted) {
      return count;
    }

    count = count ? Number(count) + 1 : 1;

    localStorage.setItem("dd_visit_count", count);
    sessionStorage.setItem("dd_visit_is_counted", "1");

    return count;
  }

  // FBT description toggle
  function cartFBTDescToggle() {
    document.querySelectorAll('.moreless_button').forEach(function(element) {
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var parent = this.parentElement;
        parent.querySelector(".extended_content").classList.toggle("hidden");
        parent.querySelector(".truncated_content").classList.toggle("hidden");
      });
    });
  }

  function rewardsClick() {
    document.querySelectorAll('.mobile_dropdown_diamonds, .dropdown_diamonds').forEach(function(element) {
      element.addEventListener('click', function(e) {
        const rewardsTab = document.querySelector(".ssw-reward-tab");
        e.preventDefault();
        rewardsTab.click();
      });
    });
  }

  window.mobileCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  function showWidgetsOnScroll() {
    let activated = false;
    window.addEventListener("scroll", throttle(function() {
      if (activated) return;
      const exampleHomepageElement = document.querySelector('.mobile-cta-homepage');
      if (window.scrollY > 500) {
        // console.log('scrolled 500px, activating widgets now');
        activated = true;

        // only show on homepage mobile
        if (window.mobileCheck() === true && exampleHomepageElement === null) {
          var style = document.createElement('style');
          style.innerHTML = 'html body .ssw-reward-tab.ssw-reward-tab-left, html #ssw-widget-review-bar .ssw-reviews-caption .ssw-reviews-caption__element, #reamazejs-container { display: none !important; }';
          document.body.appendChild(style);
          return;
        }

        var style = document.createElement('style');
        style.innerHTML = 'html body .ssw-reward-tab.ssw-reward-tab-left, html #ssw-widget-review-bar .ssw-reviews-caption .ssw-reviews-caption__element, #reamazejs-container { display: block !important; }';
        document.body.appendChild(style);
      }
    }));
  }

  function scrollToTop() {
    let activated = false;
    const trigger = document.getElementById('js-scroll-top');
    if (trigger === null) return;

    window.addEventListener("scroll", throttle(function() {
      if (window.scrollY > 100 && !activated) {
        activated = true;
        // console.log('scrolled 100px, activating widgets now');
        trigger.classList.remove('hidden');
      }
      
      if (window.scrollY <= 100 && activated) {
        activated = false;
        // console.log('scrolled back to top');
        trigger.classList.add('hidden');
      }
    }));

    document.getElementById('js-scroll-top').addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /**
   * Sets the custom CSS variable --vh to a value representing 1% of the window height.
   * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
   */
  function setVH() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  function allowRadioUncheck() {
    // console.log('init');
    // document.querySelectorAll('.checkbox-container input[type="radio"]').forEach(function(radio) {
    //   console.log('added');
    //   radio.addEventListener('click', function(e) {
    //     console.log('clicked', this.checked, this.value);
    //     if (this.checked && this.value !== '') {
          
    //     //   const nearestRadioButton = this.closest('.checkbox-list').querySelector('input[type="radio"][value=""]');
    //     //   console.log(nearestRadioButton);
    //     //   if (nearestRadioButton) {
    //     //     console.log('in')
    //     //     this.checked = false;
    //     //     nearestRadioButton.click();
    //     //   }
    //     }

    //     return true;
    //   });
    // });
  }

  window.addEventListener('resize', () => setVH());

  // window.addEventListener('facet:updated', function(event) {
  //   console.log('reinitialized');
  //   allowRadioUncheck();
  // });

  // Show locale selector if not set yet
  document.addEventListener('DOMContentLoaded', function () {
    checkIfLocaleIsSet();
    cartFBTDescToggle();
    rewardsClick();
    showWidgetsOnScroll();
    scrollToTop();
    setVH();

    allowRadioUncheck();
  });
})();

export { CheckoutQuickAdd };

function close_popup(){
  if(document.querySelector('.popup_image_icon_content_main .close_popup')){
    document.querySelector('.popup_image_icon_content_main .close_popup').addEventListener('click', function(){
      document.querySelector('.popup_image_icon_content_main').classList.add('hidden');
      document.querySelector('.popup_image_icon_content_main .popup_image_icon_content_data').innerHTML = '';
    });
  }
}

if(document.querySelectorAll('.image_icon_content_main .popup_JS').length){
  document.querySelectorAll('.image_icon_content_main .popup_JS').forEach(function(popup_JS){
    popup_JS.addEventListener('click', function(){
      var popup_html = this.closest('.single_image_icon_content').innerHTML;
      if(document.querySelector('.popup_image_icon_content_main .popup_image_icon_content_data')){
        document.querySelector('.popup_image_icon_content_main .popup_image_icon_content_data').innerHTML = popup_html;
        document.querySelector('.popup_image_icon_content_main .icon_content_inner .content').classList.remove('sm-max:hidden');
        document.querySelector('.popup_image_icon_content_main .icon_content_inner .popup_JS ').classList.add('hidden');
        document.querySelector('.popup_image_icon_content_main .icon_content_inner .close_popup').classList.remove('hidden');
        document.querySelector('.popup_image_icon_content_main').classList.remove('hidden');
        close_popup();
      }
    });
  });
}

document.addEventListener('mouseup', function(e) {
  var popup__close = document.querySelector(".popup_image_icon_content_main .popup_image_icon_content_data");
  if (!popup__close.contains(e.target) && popup__close !== e.target) {
    if(document.querySelector('.popup_image_icon_content_main .close_popup')){
      document.querySelector('.popup_image_icon_content_main .close_popup').click();
    }
  }
});

